/* eslint-disable react/prefer-stateless-function */
import PropTypes from 'prop-types'
import React from 'react'

import Field from 'components/Field'
import InputRadios from 'components/InputRadios'

export default class FieldWithInputRadios extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ checked: nextProps.checked || '' })
  }

  //handleChange = (e) => {
  //  this.setState({ checked: e.target.value })
  //}

  render() {
    //const { title, ...props } = this.props
    //const { inputs, title, ...props } = this.props
    //const { checked, inputs, name, title, onChange } = this.props
    const { inputs, name, title, onChange } = this.props
    const { checked } = this.state

    return (
      <Field className="FieldWithInputRadios uk-form-stacked">
        {title &&
          <h3 className="uk-form-label">
            {title}
          </h3>
        }
        {/*<InputRadios {...props} />*/}
        {/*<InputRadios {...props} inputs={inputs} />*/}
        <InputRadios checked={checked} inputs={inputs} name={name} onChange={onChange} />
      </Field>
    )
  }
}

FieldWithInputRadios.propTypes = {
  //checked: PropTypes.oneOf([PropTypes.bool, PropTypes.string]),
  //checked: PropTypes.string,
  checked: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inputs: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/FieldWithInputRadios/FieldWithInputRadios.js